"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xml_1 = require("./xml");
function uintToString(uintArray) {
    return uintArray.reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
    }, '');
}
exports.uintToString = uintToString;
function uintToDecodedXmlString(uintArray) {
    var encodedString = uintToString(uintArray);
    return decodeURIComponent(escape(xml_1.cleanUp(encodedString)));
}
exports.uintToDecodedXmlString = uintToDecodedXmlString;
function uintToDecodedString(uintArray) {
    var encodedString = uintToString(uintArray);
    return decodeURIComponent(escape(encodedString));
}
exports.uintToDecodedString = uintToDecodedString;
function stringToUint(inputString) {
    if (inputString === void 0) { inputString = ''; }
    var encodedString = unescape(encodeURIComponent(inputString));
    var charList = encodedString.split('');
    var uintArray = [];
    for (var i = 0; i < charList.length; i++) {
        uintArray.push(charList[i].charCodeAt(0));
    }
    return new Uint8Array(uintArray);
}
exports.stringToUint = stringToUint;
